import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../../commonFields";

export const verticalFilterBlockConfig: Omit<RegisteredComponent, "component"> =
  {
    name: "Vertical filter",
    canHaveChildren: false,
    noWrap: true,
    inputs: [
      {
        name: "filterVariant",
        type: "enum",
        enum: ["index", "search"],
        defaultValue: "index",
        localized: false,
      },
      {
        name: "variant",
        type: "enum",
        enum: ["standard", "button-trigger"],
        localized: false,
        required: false,
        defaultValue: "standard",
      },
      {
        name: "name",
        type: "string",
        localized: true,
        required: false,
        helperText: "Filter's name which appears above the filter",
        defaultValue: {
          "@type": "@builder.io/core:LocalizedValue",
          Default: "Filter",
        },
      },

      {
        name: "clearAll",
        type: "object",
        subFields: [
          {
            name: "text",
            type: "string",
            localized: true,
            required: true,
            defaultValue: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "Clear all",
            },
          },
          DLD_FIELD,
          DLT_FIELD,
        ],
      },
      {
        name: "selectAll",
        type: "object",
        subFields: [
          {
            name: "text",
            type: "string",
            localized: true,
            required: true,
            defaultValue: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "Select all",
            },
          },
          DLD_FIELD,
          DLT_FIELD,
        ],
      },
      {
        name: "deselectAll",
        type: "object",
        subFields: [
          {
            name: "text",
            type: "string",
            localized: true,
            required: true,
            defaultValue: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "Deselect all",
            },
          },
          DLD_FIELD,
          DLT_FIELD,
        ],
      },
      {
        name: "applyFilter",
        type: "object",
        subFields: [
          {
            name: "text",
            type: "string",
            localized: true,
            required: true,
            defaultValue: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "Apply filter",
            },
          },
          DLD_FIELD,
          DLT_FIELD,
        ],
      },
      {
        name: "filterAnalytics",
        type: "object",
        subFields: [DLD_FIELD, DLT_FIELD],
      },
      {
        name: "configuration",
        type: "list",
        showIf: (options) => options.get("filterVariant") === "index",
        helperText:
          "These fields define the configuration of the filters displayed and their order.",
        subFields: [
          {
            name: "parameterName",
            type: "string",
            helperText:
              "The value here must be the same as the one defined under the parameter name in the categorization of the Index card entry.",
            localized: false,
            required: true,
          },
        ],
      },
    ],
  };
